import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';
import { Block } from 'components/block';
import { useBlockEditMode } from 'components/block/utils';
import { InfoCircleIcon } from 'components/icons';
import { DomainsForm, DomainsFormProps } from 'user/forms/domains-form';

export const DomainBlock: FC = () => {
  const { t } = useTranslation();

  const {
    buttons: domainBlockButtons,
    isEditMode: isEditModeDomains,
    setIsEditMode: setIsEditDomainsMode,
    formName: domainFormName,
  } = useBlockEditMode({
    formName: 'domains-form',
  });

  const domainFormProps: DomainsFormProps = {
    editMode: isEditModeDomains,
    formName: domainFormName,
    setEditMode: setIsEditDomainsMode,
  };

  const infoCircle = (
    <Tooltip title="Domains are a sphere of activity where you have any experience.">
      <InfoCircleIcon />
    </Tooltip>
  );

  return (
    <Block
      title={t('Domains')}
      extra={domainBlockButtons}
      subTitle={infoCircle}
    >
      <DomainsForm {...domainFormProps} />
    </Block>
  );
};
